/**
 * Comparative Analysis – period-over-period (WoW, MoM, YoY)
 */

function getPrice(item) {
  return parseFloat(item.totalPrice || item.price || item.revenue || 0) || 0;
}

export function getPreviousPeriod(startDate, endDate, periodType) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const duration = end - start;
  let prevStart, prevEnd;
  switch (periodType) {
    case 'day':
      prevEnd = new Date(start);
      prevEnd.setDate(prevEnd.getDate() - 1);
      prevStart = new Date(prevEnd);
      prevStart.setDate(prevStart.getDate() - Math.floor(duration / (1000 * 60 * 60 * 24)));
      break;
    case 'week':
      prevEnd = new Date(start);
      prevEnd.setDate(prevEnd.getDate() - 1);
      prevStart = new Date(prevEnd);
      prevStart.setDate(prevStart.getDate() - 6);
      break;
    case 'month':
      prevEnd = new Date(start);
      prevEnd.setMonth(prevEnd.getMonth() - 1);
      prevStart = new Date(prevEnd);
      prevStart.setMonth(prevStart.getMonth() - 1);
      break;
    case 'year':
      prevEnd = new Date(start);
      prevEnd.setFullYear(prevEnd.getFullYear() - 1);
      prevStart = new Date(prevEnd);
      prevStart.setFullYear(prevStart.getFullYear() - 1);
      break;
    default:
      prevEnd = new Date(start);
      prevEnd.setMonth(prevEnd.getMonth() - 1);
      prevStart = new Date(prevEnd);
      prevStart.setMonth(prevStart.getMonth() - 1);
  }
  return { start: prevStart, end: prevEnd };
}

export function calculatePeriodComparison(currentData, previousData, periodType) {
  const currentList = Array.isArray(currentData) ? currentData : [];
  const previousList = Array.isArray(previousData) ? previousData : [];
  const currentTotal = currentList.length;
  const previousTotal = previousList.length;
  const currentRevenue = currentList.reduce((sum, item) => sum + getPrice(item), 0);
  const previousRevenue = previousList.reduce((sum, item) => sum + getPrice(item), 0);
  const bookingsChange = previousTotal > 0
    ? ((currentTotal - previousTotal) / previousTotal) * 100
    : currentTotal > 0 ? 100 : 0;
  const revenueChange = previousRevenue > 0
    ? ((currentRevenue - previousRevenue) / previousRevenue) * 100
    : currentRevenue > 0 ? 100 : 0;
  return {
    bookings: {
      current: currentTotal,
      previous: previousTotal,
      change: bookingsChange,
      changeAbs: currentTotal - previousTotal,
      isPositive: bookingsChange >= 0,
    },
    revenue: {
      current: currentRevenue,
      previous: previousRevenue,
      change: revenueChange,
      changeAbs: currentRevenue - previousRevenue,
      isPositive: revenueChange >= 0,
    },
    periodType: periodType || 'month',
  };
}

export function formatComparisonIndicator(change) {
  const isPositive = change >= 0;
  const absChange = Math.abs(change);
  return {
    percentage: absChange.toFixed(1),
    arrow: isPositive ? '\u2191' : '\u2193',
    color: isPositive ? '#4CAF50' : '#F44336',
    isPositive,
    formatted: (isPositive ? '+' : '') + absChange.toFixed(1) + '%',
  };
}
